import { render, staticRenderFns } from "./WorkersList.vue?vue&type=template&id=160ac1f3&"
import script from "./WorkersList.vue?vue&type=script&lang=js&"
export * from "./WorkersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports